/**
 * Workflows P5-7 (DEC-098): the `verify_email` step, a one-time code the visitor receives at the e-mail address the
 * workflow already knows. Mirrors backend `app/core/constants/workflow_verify.py`.
 */

/** `kind` of the `workflow_step` card payload. */
export const VERIFY_CARD_KIND = "verify_email";
/** Digits of the code (the same length as the end-user sign-in code). */
export const VERIFY_CODE_LENGTH = 6;
/** Wrong codes the visitor may enter before the step fails; the code service burns the code at five. */
export const VERIFY_WRONG_CODES_MAX = 3;
/** Messages that are not a code at all before the step fails. */
export const VERIFY_NOT_A_CODE_MAX = 5;
/** Minutes a code works after it was sent (the end-user sign-in code lives as long). */
export const VERIFY_CODE_TTL_MINUTES = 10;
/** "Resend code" opens this many seconds after the first code, and only once. */
export const VERIFY_RESEND_AFTER_S = 60;
export const VERIFY_RESENDS_MAX = 1;
/** A visitor may type the code with spaces or dashes (`482 913`, `482-913`). */
export const VERIFY_CODE_SEPARATORS = /[\s-]/g;
/** The visible chat message of a code the visitor sent (the code itself only travels as `workflow_reply.value`). */
export const VERIFY_CODE_MASK = "•";

/** The card's two stages: offer to send the code, then wait for it. */
export const VERIFY_STAGES = ["send", "enter"] as const;
export type VerifyStage = (typeof VERIFY_STAGES)[number];

/** Ids of the buttons on a code card: both make the server e-mail a code, so both carry the bot check. */
export const SEND_CODE_BUTTON_ID = "send_code";
export const RESEND_CODE_BUTTON_ID = "resend_code";

/** Channels that cannot show a button or a bot check: the code is sent as the step is reached, `resend` asks for another. */
export const VERIFY_AUTO_SEND_CHANNELS = ["messenger", "email"] as const;
/** Why the step took its failed exit (`detail.reason` of the run log). */
export const VERIFY_FAILURES = ["no_email", "expired", "too_many_attempts", "not_a_code", "rate_limited", "send_failed", "blocked", "unavailable"] as const;
export type VerifyFailure = (typeof VERIFY_FAILURES)[number];
/** The outcomes path analysis counts for the step (mirrors `STEP_OUTCOMES.verify_email`). */
export const VERIFY_OUTCOMES = ["verified", "failed", "expired"] as const;
/** The code a Playground (preview) conversation accepts: nothing is e-mailed from a preview. */
export const VERIFY_PREVIEW_CODE = "123456";
